import { useDispatch, useSelector } from "react-redux";

import {
  getWithdrawalPolicy,
  submitWithdrawalRequestAction,
} from "@/store/slices/withdrawal/withdrawal.action";
import {
  clearRequestState,
  resetWithdrawalState,
} from "@/store/slices/withdrawal/withdrawal.slice";
import { AppDispatch, RootState } from "@/store/store";

export const useWithdrawal = () => {
  const dispatch = useDispatch<AppDispatch>();

  const {
    policyData,
    isLoadingPolicy,
    isSubmittingRequest,
    policyError,
    requestError,
    requestSuccess,
  } = useSelector((state: RootState) => state.withdrawal);

  const fetchPolicyData = () => {
    dispatch(getWithdrawalPolicy());
  };

  const submitRequest = async (withdrawalReason: string) => {
    if (!policyData?.referenceId) {
      throw new Error("Policy reference ID not available");
    }

    return dispatch(
      submitWithdrawalRequestAction({
        policyReference: policyData.referenceId,
        withdrawalReason,
      })
    );
  };

  const clearRequest = () => {
    dispatch(clearRequestState());
  };

  const resetState = () => {
    dispatch(resetWithdrawalState());
  };

  return {
    policyData,
    isLoadingPolicy,
    isSubmittingRequest,
    policyError,
    requestError,
    requestSuccess,
    fetchPolicyData,
    submitRequest,
    clearRequest,
    resetState,
  };
};
